
export default {
  bottomList: state => state.bottomList,
  rightsList: state => state.rightsList,
  conditionList: state => state.conditionList,
  deadline: state => state.deadline,
  isup: state => state.isup,
  privBuyList: state => state.privBuyList,
  privLeft: state => state.privLeft,
  privList: state => state.privList,
  privUpV2List: state => state.privUpV2List,
  viplevel: state => state.viplevel
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/home/store/getters.js